import styled from "styled-components"

export const Background = styled.div<{
  active: boolean
  headerVisible?: boolean
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${({ theme, headerVisible }) =>
    headerVisible
      ? theme.zIndexes.modalUnderHeaderLayer
      : theme.zIndexes.modalTopLayer};
  overflow: auto;
  width: 100%;
  height: 100%;
  transition: opacity 250ms ease-in-out;
  opacity: ${({ active }) => (active ? 1 : 0)};
  pointer-events: ${({ active }) => (active ? "auto" : "none")};
  background-color: rgba(59, 63, 66, 0.35);
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Box = styled.div`
  --vertical-space: 90px;
  --horizontal-space: 30px;

  width: auto;
  min-height: calc(100vh - 2 * var(--vertical-space));

  display: flex;
  align-items: center;
  justify-content: center;

  margin: var(--vertical-space) var(--horizontal-space);
`

export const Content = styled.div`
  box-sizing: border-box;
  position: relative;

  * {
    max-width: 100%;
  }
`

export const BoxContent = styled(Content)`
  background-color: ${({ theme }) => theme.color.backgroundInverted};
  box-shadow: 0 2px 20px 0 ${({ theme }) => theme.color.lightShadow};
`
